var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4646_1548)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0536 11.5077C12.085 11.5262 12.1245 11.5262 12.1558 11.5077C14.5632 10.0856 16.3172 8.84058 16.7079 6.49642C16.7389 6.31043 16.7544 6.1167 16.7544 5.91521C16.7544 5.18677 16.5103 4.57844 16.022 4.09023C15.5338 3.60202 14.9255 3.35791 14.1971 3.35791C13.7941 3.35791 13.4105 3.44315 13.0463 3.61364C12.6821 3.78413 12.3682 4.02436 12.1047 4.33434C11.8412 4.02436 11.5274 3.78413 11.1632 3.61364C10.7989 3.44315 10.4154 3.35791 10.0124 3.35791C9.28394 3.35791 8.67561 3.60202 8.1874 4.09023C7.69918 4.57844 7.45508 5.18677 7.45508 5.91521C7.45508 6.1167 7.47058 6.31043 7.50157 6.49642C7.89266 8.84295 9.6441 10.0837 12.0536 11.5077Z",
    fill: "url(#paint0_linear_4646_1548)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4646_1548",
    x1: 12.1047,
    y1: 3.35791,
    x2: 12.1047,
    y2: 11.5378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE5FA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2717"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4646_1548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/health-icon.a9a7c926c16784172ec312384f3ed593.svg";
export { ForwardRef as ReactComponent };